import { useToken } from "@chakra-ui/react";

const useColors = (tokens: string[]) => {
  const colors = useToken("colors", tokens);
  return colors;
};

export default useColors;
